import { ComponentAPI } from '@philips-internal/oswald-ui-core';
export default class ApprovalPhasesDetailsAPI extends ComponentAPI {
    setData(data) {
        this.setState({ ...data });
    }
}
//# sourceMappingURL=approval-phases-details-api.js.map